// extracted by mini-css-extract-plugin
export var contactSection = "index-module--contactSection--3VYtN";
export var container = "index-module--container--fUiTm";
export var section = "index-module--section--sDkEr";
export var talkToUs = "index-module--talkToUs--LNte4";